// extracted by mini-css-extract-plugin
export default {"description":"model-viewer-rotation-description_description__BYNNE"};